import { Shield, Award, Star } from "lucide-react";

const TrustBadges = () => {
  return (
    <section className="py-6 bg-[#090A0F] border-b border-white/10 relative overflow-hidden" data-testid="trust-badges-section">
      <div className="absolute inset-0 pointer-events-none" aria-hidden="true" style={{ background: "radial-gradient(ellipse at 20% 0%, rgba(255,42,66,0.18), transparent 50%), radial-gradient(ellipse at 80% 100%, rgba(139,92,246,0.18), transparent 50%)" }} />
      <div className="max-w-7xl mx-auto px-4 relative">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-3">
            <div className="flex -space-x-2">
              {[1,2,3,4,5].map(i => (
                <div key={i} className="w-8 h-8 rounded-full bg-gradient-to-br from-red-500 to-orange-500 border-2 border-black flex items-center justify-center">
                  <span className="text-white text-xs font-bold">{String.fromCharCode(64 + i)}</span>
                </div>
              ))}
            </div>
            <p className="text-white font-bold text-sm md:text-base">
              Trusted by <span className="text-gradient-fire font-black">1000+</span> Brands Across India
            </p>
          </div>
          <div className="flex items-center gap-4 md:gap-6">
            <div className="flex items-center gap-2 px-3 py-1.5 bg-red-500/10 rounded-lg border border-red-500/30">
              <Shield size={16} className="text-red-400" />
              <span className="text-xs font-bold text-white">98% Approval</span>
            </div>
            <div className="flex items-center gap-2 px-3 py-1.5 bg-violet-500/10 rounded-lg border border-violet-500/30">
              <Star size={16} className="text-violet-400 fill-violet-400" />
              <span className="text-xs font-bold text-white">4.9/5 Rating</span>
            </div>
            <div className="flex items-center gap-2 px-3 py-1.5 bg-emerald-500/10 rounded-lg border border-emerald-500/30">
              <Award size={16} className="text-emerald-400" />
              <span className="text-xs font-bold text-white">14-Day Launch</span>
            </div>
          </div>
          <div className="flex items-center gap-3 text-gray-400 text-xs font-medium">
            <span>Launch on:</span>
            <div className="flex items-center gap-2">
              {[["Myntra", "bg-rose-500/20 border-rose-400/30"], ["Nykaa", "bg-pink-500/20 border-pink-400/30"], ["Ajio", "bg-blue-500/20 border-blue-400/30"], ["Blinkit", "bg-yellow-500/20 border-yellow-400/30"]].map(([p, c]) => (
                <span key={p} className={`px-2 py-1 ${c} border rounded text-white text-xs font-bold`}>{p}</span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustBadges;
